import { api } from './authService';

export interface SediuSocial {
  strada: string | null;
  numar: string | null;
  localitate: string | null;
  judet: string | null;
  codPostal: string | null;
  tara: string | null;
}

export interface CompanyDGData {
  CUI: string;
  denumireCompanie: string | null;
  adresaDomiciliuFiscalText: string | null;
  sediuSocial: SediuSocial;
  nrInmatriculareRC: string | null;
  telefon: string | null;
  fax: string | null;
  codPostal: string | null;
  codCAENPrincipal: string | null;
  formaJuridicaOrganizareProprietate: string | null;
  dataInregistrarii: string | null;
  stareInregistrare: string | null;
  IBAN: string | null;
}

export interface CompanyDGResponse {
  success: boolean;
  data: CompanyDGData;
}

export interface CompanyDGBatchResponse {
  success: boolean;
  data: CompanyDGData[];
}

export const companiesDGService = {
  /**
   * Obtine date generale pentru o firma din ANAF
   */
  async getCompanyDG(cui: string, date?: string): Promise<CompanyDGResponse> {
    const params = new URLSearchParams();
    if (date) {
      params.append('date', date);
    }
    
    const url = `/companies/dg/${encodeURIComponent(cui)}${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await api.get(url);
    return response.data;
  },

  /**
   * Obtine date generale pentru mai multe firme din ANAF
   */
  async getCompaniesDGBatch(items: Array<{ cui: string; date?: string }>): Promise<CompanyDGBatchResponse> {
    const response = await api.post('/companies/dg', { items });
    return response.data;
  }
};
